import { AxiosInstance } from "axios";
import createAuthRefreshInterceptor, {
  AxiosAuthRefreshRequestConfig,
} from "axios-auth-refresh";
import { History } from "history";

import { sessionResourcePath } from "@/modules/auth/api/resources/session/sessionResourceConsts";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";

export const applyAuthRefreshInterceptor = (
  axiosInstance: AxiosInstance,
  history: History
) => {
  createAuthRefreshInterceptor(
    axiosInstance,
    createAuthRefreshCall(axiosInstance, history)
  );
};

const createAuthRefreshCall = (
  axiosInstance: AxiosInstance,
  history: History
) => async () => {
  try {
    await axiosInstance.put(sessionResourcePath, undefined, {
      skipAuthRefresh: true,
    } as AxiosAuthRefreshRequestConfig);
  } catch (err) {
    history.replace(authenticatedRouting.buildUrl("signOut"));
    return Promise.reject(err);
  }
};
